/*
 * @Author: 'qhy' '272921690@qq.com'
 * @Date: 2022-11-19 11:49:39
 * @LastEditors: 'qhy' '272921690@qq.com'
 * @LastEditTime: 2022-12-27 16:16:06
 * @FilePath: \edu_ytsr_show_school_vue\src\utils\config.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'
if (process.env.NODE_ENV == 'development') {
    axios.defaults.baseImgURL = 'http://edures.yunruanxinxi.cn:19100/api/biz/'  
}else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseImgURL = 'http://apis.tszyjyw.com:19100/api/biz/';
}
axios.defaults.baseURL = `${axios.defaults.baseImgURL}SchoolInterfaces`;
export default {
    baseURL:axios.defaults.baseURL,
    baseImgURL:axios.defaults.baseImgURL,
    organizeId:'centralPlatformId',
    //  schoolId:'349174757440096133'
    // 遵化线上
    // schoolId:'349174005351057285'
    // 唐山市丰润区综合职业技术教育中心
    // schoolId:'375906216582317766'
    // 河北唐山职业技能公共实训中心
    // schoolId:'376994877495314118'
} 